const styles = (theme) => ({
  uploadContainer: {
    border: "1px solid black",
    height: "25vh",
    width: "30%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    borderRadius: "10px",
  },
  mainContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "30vh",
    flexWrap: "nowrap",
    flexDirection: "column",
    margin: "2%",
  },

  choose: {
    color: "white",
    display: "inline-block",
    background: "#05a792",
    border: "none",
    padding: "7px 15px",
    fontWeight: "700",
    borderRadius: "3px",
    whiteSpace: "nowrap",
    cursor: "pointer",
    fontSize: "10pt",
  },
  dataContainer: {
    display: "flex",
    justifyContent: "center",
    margin: "5px",
    padding: "5px",
    flexDirection: "column",
  },
  outerDiv: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
  },

  invalidShipmentContainer: {
    border: "1px solid black",
    padding: "5px",
  },
});

export default styles;
